import { actionTypes } from '../actions/params';

// DEFAULT STATE
export const initParams = {
  perfStartDate: '', 
  perfEndDate: '', 
  ticker:'',
};

// WRITES
const params = (state = {}, action) => {
  if (state === undefined) {
    return {};
  }
  switch (action.type) {

    case actionTypes.SET_CHART_TICKER:
      return Object.assign({}, state, {
        ticker: action.value,
        chartTicker: action.value,
      });

    case actionTypes.SET_PERF_START_DATE:
      return Object.assign({}, state, {
        perfStartDate: action.payload,
      });
    case actionTypes.SET_PERF_END_DATE:
      return Object.assign({}, state, {
        perfEndDate: action.payload,
      });
    default:
      return state;
  }
};


// READS
export const getChartTicker = (state) => state.params.ticker;
export const getPerfStartDate = (state) => state.params.perfStartDate;
export const getPerfEndDate = (state) => state.params.perfEndDate;
export default params;



// WEBPACK FOOTER //
// ./src/reducers/params.js